// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.row({
  structureId: __t.u64().primaryKey().name("structure_id"),
  hp: __t.i32(),
  state: __t.string(),
  reinforcedUntil: __t.timestamp().name("reinforced_until"),
  updatedAt: __t.timestamp().name("updated_at"),
});
